import { styled } from "styled-components";

import { DateInput } from "shared/ui/inputs";

const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

const RangeLabel = styled.span`
  color: var(--text-black, #111);
  font-family: "Noto Sans KR";
  font-size: 16px;
  font-weight: 400;
  line-height: 140%;
`;

const Separator = styled.span`
  color: var(--text-black, #111);
`;

/**
 * 시작일 ~ 종료일을 고르는 날짜 범위 입력.
 *
 * @param startDate     시작일 값(YYYY-MM-DD)
 * @param endDate       종료일 값
 * @param onChangeStart (event) => void
 * @param onChangeEnd   (event) => void
 * @param label         앞에 붙일 라벨(예: "검색 범위"). 미지정 시 라벨 없음.
 */
export function DateRangeField({
  startDate,
  endDate,
  onChangeStart,
  onChangeEnd,
  label,
}) {
  return (
    <Wrap>
      {label ? <RangeLabel>{label}</RangeLabel> : null}
      <DateInput type="date" value={startDate} onChange={onChangeStart} />
      <Separator>-</Separator>
      <DateInput type="date" value={endDate} onChange={onChangeEnd} />
    </Wrap>
  );
}

export default DateRangeField;
